export const heightSmall = 70

export const heightLarge = 100

/* has to be higher than the elements rendered by rails views for the "header" layout */
export const zIndex = 10

export const searchResultsPanelZIndex = 3

export const searchInputZIndex = 3

export const mobileMenuZIndex = 4

export const navbarSizeBreakpoint = 'md' as const
